import { render } from "./ModalSeleccionLanding.vue?vue&type=template&id=2bc8b230&scoped=true"
import script from "./ModalSeleccionLanding.vue?vue&type=script&lang=js"
export * from "./ModalSeleccionLanding.vue?vue&type=script&lang=js"

import "./ModalSeleccionLanding.vue?vue&type=style&index=0&id=2bc8b230&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc8b230"]])

export default __exports__